<div nz-row [ngClass]="'home-second-header'">
    <div nz-col nzSpan="24">

        <div nz-row [ngClass]="'home-second_content'">
            <div nz-col nzSpan="12" nzOffset="3" class="home-left">

                <h3 class="welcome-string">
                    <span class="hand-write">Bun venit draga&nbsp;</span>
                    <span class="welcome-name" *ngIf="currentUser == null">
                        antreprenorule!
                    </span>
                    <span class="user-name" *ngIf="currentUser != null">
                        {{currentUser.firstname}}!
                    </span>
                </h3>

                <div nz-row>
                    <div nz-col nzSpan="24" nzOffset="0">
                        <div nz-row>
                            <div nz-col nzSpan="24" nzOffset="0" class="h-strings mobile-block">
                                <p>
                                    <strong>
                                        Aplicatia doctorbusiness.ro este consultantul tau financiar care iti transforma
                                        in
                                        <span class="five">5</span>
                                        secunde cifrele din balanta contabila intr-o poveste despre afacerea ta.
                                    </strong>
                                </p>

                                <p>
                                    Povestea este scrisa intr-un limbaj prietenos. Vei intelege foarte usor care este
                                    starea de sanatate a business-ului tau, care sunt vulnerabilitatile si ce e de facut
                                    pentru o mai buna performanta.
                                </p>
                            </div>
                        </div>
                        <div nz-row>
                            <div nz-col nzSpan="14" nzOffset="0" class="h-strings mobile-block">
                                <p>
                                    <strong>
                                        Concret, tu incarci o balanta din orice luna doresti (in format Excel) si
                                        primesti in 5 secunde un
                                        <a href="#raport-de-analiza" style="color: #4855ee">
                                            raport de analiza financiara
                                        </a>
                                    </strong>
                                </p>

                                <ul>
                                    <li>drumul tau de la vanzari la profit</li>
                                    <li>diferenta dintre profit si cash</li>
                                    <li>
                                        un diagnostic al starii de sanatate a firmei,
                                    </li>
                                    <li>ce ai de primit si ce ai de dat,</li>
                                    <li>
                                        recomandari personalizate pe rezultatele tale.
                                    </li>
                                </ul>

                                <p>
                                    <strong>
                                        Te asigur ca vei lua cel putin o decizie buna
                                    </strong>
                                    dupa citirea raportului de analiza financiara.
                                </p>
                                <div style="height: 60px"></div>
                            </div>
                            <div nz-col nzSpan="10" nzOffset="0" class="mobile-block">
                                <div class="demo-video-desktop" (click)="showModal()">
                                    <span>Demo</span>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 485 485"
                                        style="enable-background:new 0 0 485 485;" xml:space="preserve">
                                        <g>
                                            <path d="M0,0v485h485V0H0z M455,455H30V30h425V455z"></path>
                                            <polygon points="181.062,148.425 181.062,336.575 343.938,242.5 	"></polygon>
                                        </g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                    </svg>
                                </div>
                                <div class="demo-video-mobile" (click)="showModalMobile()">
                                    <span>Demo</span>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 485 485"
                                        style="enable-background:new 0 0 485 485;" xml:space="preserve">
                                        <g>
                                            <path d="M0,0v485h485V0H0z M455,455H30V30h425V455z"></path>
                                            <polygon points="181.062,148.425 181.062,336.575 343.938,242.5 	"></polygon>
                                        </g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div nz-col nzSpan="24" nzOffset="0" class="dropzone">
                        <a routerLink="/upload" (click)="goTop()">
                            <img src="/assets/img/btn-incarca.png">
                        </a>

                        <p class="c-white">
                            Balanţa sintetică în Excel şi vei obţine
                        </p>
                    </div>
                </div>
            </div>
            <div nz-col nzSpan="8" nzOffset="0" class="home-right">
                <h3 class="hand-write c-black">
                    Povestea cifrelor în
                    <span class="circle">5</span>
                    secunde
                </h3>
                <img src="/assets/img/graphic-tornade.png">
            </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 883.56" id="bg-shape-black">
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path
                        d="M1920,883.56V137c-48.8-29.63-53.6-32.84-104.77-63.93-87-52-184-88-284-67a221.5,221.5,0,0,0-60.47,22.7c-55.22,30.42-95.53,81.8-128.53,134.3-10.67,16.5-20.5,33.22-29.85,50-46.76,83.93-81.48,169.49-148.15,237a248.5,248.5,0,0,1-50.56,36.63,242,242,0,0,1-179.44,21.38c-104-28-203-55-308-70.16-20.33-3-40.72-5.36-61.19-7a770,770,0,0,0-124-.57c-26.44,1.61-52.62,4.35-78.67,7.93-77.86,10.67-154.58,29-231,47.17q-39.1,10.16-81.06,22.8Q25.67,515.66,0,524V883.56">
                    </path>
                </g>
            </g>
        </svg>
    </div>
</div>

<!-- <img src="/assets/img/a-book-g79c05e122_1920.jpg" />
        <div class="db-moto">
            <h2 class="an-1">Povestea cifrelor în 5 secunde.</h2>
        </div> -->

<!-- <div nz-row [ngClass]="'home-header'" style="text-align: center">
    <div nz-col nzSpan="16" nzOffset="4">
        <h2 nz-typography style="text-align: center">POVESTEA CIFRELOR IN 5 SECUNDE</h2>
        <h3 nz-typography style="text-align: center">Poţi obţine o analiză financiară din două clicuri.</h3>
        
    </div>
</div> -->

<!-- <div class="home-comp" [ngClass]="'p-5'">


</div> -->

<div nz-row [ngClass]="'home-content'">
    <div nz-col nzSpan="24">
        <h2 style="text-align: center;">
            10 lucruri pretioase cu care vin in ajutorul tau
        </h2>
        <ul nz-typography [ngClass]="'d-list'">
            <li>
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #000; color: #FFF">
                    <div class="text">
                        <span>1</span>
                        Te ajut sa ai “big picture” asupra afacerii tale.
                        <br>
                        Stiu ca esti prins cu toate provocarile zilnice si intuiesc deja ca stii cam tot ce se intampla
                        in firma ta.
                        <br>
                        Stii fiecare “copac”, insa eu te ajut sa vezi “padurea”.
                        <br>
                        Crede-ma, “din avion” se vede altfel.
                        <br>
                    </div>
                    <div class="img">
                        <img _ngcontent-nsm-c170 style="object-position: center;" src="/assets/img/home1.jpg">
                    </div>
                </div>
            </li>

            <li class="d-left d-blue">
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #e4e4e4; color: #000">
                    <div class="img">
                        <img _ngcontent-nsm-c170 src="/assets/img/home2.jpg">
                    </div>
                    <div class="text">
                        <span>2</span>
                        Te ajut sa ai “faza lunga” si sa intelegi pe ce “pedale” trebuie sa apesi astfel incat tu sa
                        ajungi la destinatia dorita.
                    </div>
                </div>
            </li>

            <li>
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #000; color: #FFF">
                    <div class="text">
                        <span>3</span>
                        Te ajut sa intelegi de unde vine diferenta dintre profitul net si cash-ul din conturi.
                    </div>
                    <div class="img">
                        <img _ngcontent-nsm-c170 src="/assets/img/3.jpg">
                    </div>
                </div>
            </li>

            <li class="d-left">
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #e4e4e4; color: #000">
                    <div class="img">
                        <img _ngcontent-nsm-c170 src="/assets/img/home4.jpg">
                    </div>
                    <div class="text">
                        <span>4</span>
                        Iti arat care este viteza reala de incasare si de plata a datoriilor si apoi te las pe tine sa
                        pui aceasta informatie in oglinda cu intelegerile contractuale pe care le ai cu partenerii tai.
                    </div>
                </div>
            </li>

            <li class="d-blue">
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #000; color: #FFF">
                    <div class="text">
                        <span>5</span>
                        Iti arat intr-un mod sintetic si relevant care este aportul tau propriu la finantarea afacerii
                        tale si cat din afacerea ta este finantata din surse externe (banci, furnizorii tai sau alti
                        creditori).
                    </div>
                    <div class="img">
                        <img _ngcontent-nsm-c170 style="object-position: right;" src="/assets/img/5.jpg">
                    </div>
                </div>
            </li>

            <li class="d-left d-green">
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #e4e4e4; color: #000">
                    <div class="img">
                        <img _ngcontent-nsm-c170 src="/assets/img/6.jpg">
                    </div>
                    <div class="text">
                        <span>6</span>
                        Iti arat prin metoda “semafor” daca afacerea ta e sanatoasa (verde), daca da semne de oboseala
                        (galben), sau daca are nevoie de tratament (rosu).
                        <br>
                        Iti fac “analizele” punandu-ti in evidenta cativa indicatori de performanta si de echilibru
                        financiar, explicati intr-o maniera in care nu trebuie sa fi facut ASE-ul ca sa intelegi ce se
                        intampla cu cifrele rezultate din afacerea ta 😊. Si iti spun si cum te situezi in functie de
                        modul ideal in care ar trebui sa fii
                    </div>
                </div>
            </li>

            <li>
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #000; color: #FFF">
                    <div class="text">
                        <span>7</span>
                        Iti fac si recomandari pe parcursul prezentarii si te invat cum sa ai control asupra cifrelor
                        mari.
                    </div>
                    <div class="img">
                        <img _ngcontent-nsm-c170 style="object-position: center;" src="/assets/img/7.jpg">
                    </div>
                </div>
            </li>

            <li class="d-left">
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #e4e4e4; color: #000">
                    <div class="img">
                        <img _ngcontent-nsm-c170 src="/assets/img/8.jpg">
                    </div>
                    <div class="text">
                        <span>8</span>
                        Te ajut sa vezi cum faci tu profitul, intr-un mod in care sa ai imaginea aia gen “pe unde intra
                        apa in barca”😊. O sa devii mai constient de dimensiunea cheltuielilor avand viziunea macro.
                    </div>
                </div>
            </li>

            <li class="d-green">
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #000; color: #FFF">
                    <div class="text">
                        <span>9</span>
                        Iti spun care ar fi valoarea firmei tale intr-o evaluare de tip “ce am, ce am de primit si ce am
                        de dat”. Mai exact, cu ce ramai daca ar fi sa inchizi totul acum (lucru care n-o sa se intample,
                        pentru ca acum te ajut si eu).
                    </div>
                    <div class="img">
                        <img _ngcontent-nsm-c170 style="object-position: center;" src="/assets/img/9.jpg">
                    </div>
                </div>
            </li>

            <li class="d-left">
                <div nz-col nzSpan="15" nzOffset="5" style="background-color: #e4e4e4; color: #000">
                    <div class="img">
                        <img _ngcontent-nsm-c170 style="object-position: center;" src="/assets/img/10.jpg">
                    </div>
                    <div class="text">
                        <span>10</span>
                        Te ajut sa identifici vulnerabilitatile afacerii tale pornind de la ansamblu la detaliu, avand
                        in fata un tablou de bord acompaniat in backstage de niste detalii relevante.
                    </div>
                </div>
            </li>

        </ul>
    </div>
</div>

<div class="dropzone-wrapper">
    <div class="dropzone">
        <a routerLink="/upload" (click)="goTop()">
            <img src="/assets/img/btn-incarca.png">
        </a>

        <p class="c-black">
            Balanţa sintetică în Excel şi vei obţine
        </p>
        <h3 class="hand-write c-black">
            Povestea cifrelor în
            <span class="circle">5</span>
            secunde
        </h3>
    </div>
</div>

<div nz-row id="raport-de-analiza" class="things">
    <div nz-col nzSpan="16" nzOffset="4">
        <h2>
            Cuprinsul raportului de analiza financiara, cu explicatii particularizate pe cifrele afacerii tale
        </h2>
    </div>

    <div class="info-columns fill home-columns" nz-col nzSpan="16" nzOffset="4">
        <ul>
            <li>
                <span class="number">01</span>
                <p>
                    Drumul tau de la VANZARI la PROFIT - (P&L/Contul de profit si Pierderi); pe ce cheltui cei mai multi
                    bani?
                </p>
            </li>
            <li>
                <span class="number">02</span>
                <p>
                    Care si unde este Diferenta dintre PROFIT ul din balanta si CASH -ul din banca?
                </p>
            </li>
            <li>
                <span class="number">03</span>
                <p>
                    'Starea de sanatate' a afacerii tale - INDICATORI FINANCIARI DE PERFORMANTA (KPI’s).
                </p>
            </li>
            <li>
                <span class="number">04</span>
                <p>
                    ACTIVE si PASIVE & Bilantul - patrimoniul tau in oglinda cu sursele de finantare
                </p>
            </li>
            <li>
                <span class="number">05</span>
                <p>
                    OBICEIURI DE PUS IN PRACTICA la fiecare final de luna.
                </p>
            </li>
            <!-- <li>
                <span class="number">06</span>
                <p>
                    Intri in posesia unei radiografii care iti arata
                    <strong>'Starea de sanatate'</strong>
                    a afacerii tale
                    <strong>-</strong>
                    INDICATORII FINANCIARI DE PERFORMANTA (KPI’s). Dintr-o singura privire poti sa vezi daca esti verde (sanatate), galben (atentie) sau rosu (nevoie de tratament). O sa gasesti detalii despre fiecare indicator si cum este interpretat rezultatul tau fata de benchmarck. Ai si recomandari pentru redresare acolo unde este cazul.
                </p>
            </li>
            <li>
                <span class="number">07</span>
                <p>
                    Primesti un ghid al
                    <strong>“</strong>
                    <strong>OBICEIURILOR DE PUS IN PRACTICA</strong>
                    <strong></strong>
                    la fiecare final de luna”. Cu aceste 5 obiceiuri simple si alocarea catorva responsabilitati in echipa ta, poti scurta drumul de la profitul din balanta la cash-ul din banca.
                </p>
            </li> -->
        </ul>
    </div>

    <!-- <div nz-col nzSpan="16" nzOffset="4">
        <img src="/assets/img/10-things/p-color-1.png" />
        <img src="/assets/img/10-things/p-color-2.png" />
        <img src="/assets/img/10-things/p-color-3.png" />
        <img src="/assets/img/10-things/p-color-4.png" />
        <img src="/assets/img/10-things/p-color-5.png" />
        <img src="/assets/img/10-things/p-color-6.png" />
        <img src="/assets/img/10-things/p-color-7.png" />
    </div> -->
</div>

<div class="dropzone-wrapper">
    <div class="dropzone">
        <a routerLink="/upload" (click)="goTop()">
            <img src="/assets/img/btn-incarca.png">
        </a>

        <p class="c-black">
            Balanţa sintetică în Excel şi vei obţine
        </p>
        <h3 class="hand-write c-black">
            Povestea cifrelor în
            <span class="circle">5</span>
            secunde
        </h3>
    </div>
</div>

<div nz-row [ngClass]="'home-first-header'">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 231.21" id="bg-shape-black-top">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M0,0H1920V94s-377.55-101.6-881.72,37.8S4.6,223.8,0,222.16"></path>
            </g>
        </g>
    </svg>
    <div class="wrapper">
        <div nz-col nzSpan="8" nzOffset="4" class="home-first-content">
            <h1 class="hand-write c-white">Draga antreprenorule,</h1>
            <p>
                <span class="c-multi">Iti multumesc</span>
                pentru increderea pe care mi-o acorzi
            </p>
            <p>
                Am creat acesta aplicatie pentru ca in cei 20 ani de experienta cu antreprenori si firme din aproape
                toate ariile de business, am constatat ca exista o nevoie reala de a primi informatii RAPIDE despre
                performanta si echilibrul business-ului tau, informatii traduse intr-un LIMBAJ COMUN, astfel incat sa nu
                trebuiasca sa fi facut ASE-ul ca sa intelegi “secretele” din balata firmei tale.
            </p>
            <p>
                Cu un efort minim si un efect maxim, printr-o simpla incarcare in aplicatie a balantei tale sintetice in
                format Excel, vei primi rapid un raport de analiza financiara cu informatii relevante, de la ansamblu la
                detaliu, despre afacerea ta si despre cifrele tale. N-o sa-ti vorbesc intr-un limbaj “pompos”, ci ca doi
                prieteni la o cafea. Sunt presarati si niste termeni economici, dar ti-i explic pe toti, astfel incat tu
                sa intelegi care este starea de sanatate a firmei tale, dar si ce ai putea sa faci ca s-o imbunatatesti.
                O sa-ti arat care-ti sunt punctele forte, dar si vulnerabilitatile. Vei avea o imagine mult mai clara,
                vei sti “de ce” si vei sti si “cum” sa actionezi in viitor. Iti pun in atentie lucruri la care poate nu
                te-ai gandit pana acum sau pe care nu le-ai vazut prezentate intr-un mod sintetic si relevant, astfel
                incat constientizarea lor sa te faca sa iei niste decizii si mai bune cu privire la afacerea ta.
            </p>
            <p>
                Roaga-ti contabilul sa-ti trimita pe e-mail o balanta sintetica in Excel, apoi te rog sa iti iei un ceai
                sau o cafea, sa te asezi confortabil intr-un loc linistit si sa te relaxezi.
            </p>
            <p>
                Incarca balanta in aplicatie cu un singur clik si … in
                <span class="circle">5</span>
                secunde vei primi o poveste cu imagini despre afacerea ta.
            </p>
        </div>
        <div nz-col nzSpan="8" nzOffset="0" class="home-first-image">

            <img src="/assets/img/ACRONIM.png">
            <div class="dropzone">
                <a routerLink="/upload" (click)="goTop()">
                    <img src="/assets/img/btn-incarca.png">
                </a>

                <p class="c-black">
                    Balanţa sintetică în Excel şi vei obţine
                </p>
                <h3 class="hand-write c-black">
                    Povestea cifrelor în
                    <span class="circle">5</span>
                    secunde
                </h3>
            </div>
        </div>
    </div>
</div>

<nz-modal [(nzVisible)]="isVisible" class="modal-video" nzTitle="Demo video" (nzOnCancel)="handleCancel()">
    <ng-container *nzModalContent>
        <video class="library" controls preload="none" data-config="some-js-object-here">
            <source src="/assets/demo_desktop.mp4" type='video/mp4'>
        </video>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isVisibleMobile" class="modal-video" nzTitle="Demo video" (nzOnCancel)="handleCancel()">
    <ng-container *nzModalContent>
        <video class="library" controls preload="none" data-config="some-js-object-here">
            <source src="/assets/demo_mobile.mp4" type='video/mp4'>
        </video>
    </ng-container>
</nz-modal>